import { createElement } from 'react';
import { element, string, bool, node, object, number, func, shape } from 'prop-types';
import { sizePropType } from '../types/props.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import InlineFlex from 'reakit/InlineFlex';
import 'reakit/Grid';
import _omit from 'lodash/omit';
import ConditionalWrap from 'conditional-wrap';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';
import Group from '../Group/index.js';
import InputMask from 'react-input-mask';
import _Input, { InputWrapper, LoadingSpinner, Icon } from './styled.js';

var Input = function Input(_ref) {
  var a11yLabel = _ref.a11yLabel,
      a11yId = _ref.a11yId,
      after = _ref.after,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      before = _ref.before,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      isLoading = _ref.isLoading,
      isRequired = _ref.isRequired,
      mask = _ref.mask,
      max = _ref.max,
      maxLength = _ref.maxLength,
      min = _ref.min,
      minLength = _ref.minLength,
      multiple = _ref.multiple,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      spellCheck = _ref.spellCheck,
      step = _ref.step,
      type = _ref.type,
      size = _ref.size,
      state = _ref.state,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yLabel", "a11yId", "after", "autoComplete", "autoFocus", "before", "defaultValue", "disabled", "inputProps", "inputRef", "isLoading", "isRequired", "mask", "max", "maxLength", "min", "minLength", "multiple", "name", "onBlur", "onChange", "onFocus", "pattern", "placeholder", "readOnly", "spellCheck", "step", "type", "size", "state", "value"]);

  return createElement(InputWrapper, _extends({
    styledSize: size
  }, props), before && createElement(InlineFlex, {
    absolute: true,
    zIndex: "3"
  }, before), after && createElement(InlineFlex, {
    absolute: true,
    right: "0",
    zIndex: "3"
  }, after), createElement(_Input, _extends({
    use: mask ? InputMask : undefined,
    after: after,
    "aria-invalid": state === 'danger',
    "aria-label": a11yLabel,
    "aria-required": isRequired,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    before: before,
    defaultValue: defaultValue,
    disabled: disabled,
    elementRef: inputRef,
    id: a11yId,
    mask: mask,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    multiple: multiple,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    pattern: pattern,
    placeholder: placeholder,
    readOnly: readOnly,
    spellCheck: spellCheck,
    state: state,
    step: step,
    styledSize: size,
    type: type,
    value: value
  }, _omit(inputProps, 'size'))), isLoading && createElement(LoadingSpinner, {
    color: "text",
    size: "small"
  }));
};

Input.Icon = Icon;
Input.Formik = formikField(Input);
Input.ReduxForm = reduxFormField(Input);
var inputPropTypes = {
  after: element,
  a11yId: string,
  a11yLabel: string,
  autoComplete: string,
  autoFocus: bool,
  before: element,
  children: node,
  className: string,
  defaultValue: string,
  disabled: bool,
  inputProps: object,
  inputRef: object,
  isLoading: bool,
  isRequired: bool,
  name: string,
  size: sizePropType,
  mask: string,
  max: number,
  maxLength: number,
  min: number,
  minLength: number,
  multiple: bool,
  pattern: string,
  placeholder: string,
  readOnly: bool,
  spellCheck: bool,
  step: number,
  state: string,
  type: string,
  value: string,
  onBlur: func,
  onChange: func,
  onFocus: func
};
Input.propTypes = inputPropTypes;
var inputDefaultProps = {
  a11yId: undefined,
  a11yLabel: undefined,
  autoComplete: undefined,
  autoFocus: false,
  children: null,
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  after: undefined,
  before: undefined,
  inputProps: {},
  inputRef: undefined,
  isLoading: false,
  isRequired: false,
  mask: undefined,
  max: undefined,
  maxLength: undefined,
  min: undefined,
  minLength: undefined,
  multiple: false,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  pattern: undefined,
  placeholder: undefined,
  readOnly: undefined,
  spellCheck: undefined,
  size: 'default',
  state: undefined,
  step: undefined,
  type: 'text',
  value: undefined
};
Input.defaultProps = inputDefaultProps; // @ts-ignore

var C = Input;

var InputField = function InputField(_ref) {
  var addonBefore = _ref.addonBefore,
      addonAfter = _ref.addonAfter,
      a11yId = _ref.a11yId,
      description = _ref.description,
      hint = _ref.hint,
      isOptional = _ref.isOptional,
      isVertical = _ref.isVertical,
      label = _ref.label,
      validationText = _ref.validationText,
      after = _ref.after,
      a11yLabel = _ref.a11yLabel,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      before = _ref.before,
      children = _ref.children,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      isLoading = _ref.isLoading,
      isRequired = _ref.isRequired,
      name = _ref.name,
      size = _ref.size,
      mask = _ref.mask,
      max = _ref.max,
      maxLength = _ref.maxLength,
      min = _ref.min,
      minLength = _ref.minLength,
      multiple = _ref.multiple,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      spellCheck = _ref.spellCheck,
      step = _ref.step,
      state = _ref.state,
      type = _ref.type,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      props = _objectWithoutPropertiesLoose(_ref, ["addonBefore", "addonAfter", "a11yId", "description", "hint", "isOptional", "isVertical", "label", "validationText", "after", "a11yLabel", "autoComplete", "autoFocus", "before", "children", "className", "defaultValue", "disabled", "inputProps", "inputRef", "isLoading", "isRequired", "name", "size", "mask", "max", "maxLength", "min", "minLength", "multiple", "pattern", "placeholder", "readOnly", "spellCheck", "step", "state", "type", "value", "onBlur", "onChange", "onFocus"]);

  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(ConditionalWrap, {
      condition: addonBefore || addonAfter,
      wrap: function wrap(children) {
        return createElement(Group, {
          isVertical: isVertical
        }, children);
      }
    }, addonBefore, createElement(C, _extends({
      after: after,
      a11yId: a11yId,
      a11yLabel: a11yLabel,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      before: before,
      className: className,
      defaultValue: defaultValue,
      disabled: disabled,
      inputProps: inputProps,
      inputRef: inputRef,
      isLoading: isLoading,
      isRequired: isRequired,
      name: name,
      size: size,
      mask: mask,
      max: max,
      maxLength: maxLength,
      min: min,
      minLength: minLength,
      multiple: multiple,
      pattern: pattern,
      placeholder: placeholder,
      readOnly: readOnly,
      spellCheck: spellCheck,
      step: step,
      state: state,
      type: type,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus
    }, elementProps), children), addonAfter);
  });
};

InputField.Formik = formikField(InputField, {
  hasFieldWrapper: true
});
InputField.ReduxForm = reduxFormField(InputField, {
  hasFieldWrapper: true
});

var inputFieldPropTypes = _objectSpread({
  addonBefore: element,
  addonAfter: element,
  inputProps: shape(inputPropTypes),
  isVertical: bool
}, fieldWrapperPropTypes, inputPropTypes);

InputField.propTypes = inputFieldPropTypes;

var inputFieldDefaultProps = _objectSpread({
  addonBefore: undefined,
  addonAfter: undefined,
  inputProps: {},
  isVertical: false
}, fieldWrapperDefaultProps, inputDefaultProps);

InputField.defaultProps = inputFieldDefaultProps; // @ts-ignore

var C$1 = InputField;
export { C as a, inputPropTypes as b, inputDefaultProps as c, InputField as d, inputFieldPropTypes as e, inputFieldDefaultProps as f, C$1 as g };